var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vm-avatar-stack flex-box flex-direction-row-reverse"},_vm._l((_vm.users),function(item,i){return _c('pic',{key:i,staticClass:"avatar-img",attrs:{"src":item.avatar,"width":_vm.w,"height":_vm.h}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }